import React, { useState } from "react";

const initialForm = {
  name: "",
  company: "",
  email: "",
  phone: "",
  service: "Container destuffing",
  location: "",
  container_count: 1,
  timeline: "",
  details: "",
};

export default function QuoteForm({ embedded = false }) {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");

  function updateField(event) {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: name === "container_count" ? Number(value) : value }));
  }

  async function submit(event) {
    event.preventDefault();
    setStatus("sending");
    try {
      const response = await fetch("/api/quote-requests/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!response.ok) throw new Error("Request failed");
      setForm(initialForm);
      setStatus("sent");
    } catch (error) {
      setStatus("error");
    }
  }

  return (
    <section className={embedded ? "quote-panel embedded" : "quote-panel page-hero"}>
      {!embedded && (
        <div>
          <p className="eyebrow">Request Quote</p>
          <h1>Get crew planning for your next container.</h1>
          <p>Use the form to share the dock location, approximate timing, and freight handling needs.</p>
        </div>
      )}
      <form className="quote-form" onSubmit={submit}>
        <label>Name<input name="name" value={form.name} onChange={updateField} required /></label>
        <label>Company<input name="company" value={form.company} onChange={updateField} /></label>
        <label>Email<input name="email" type="email" value={form.email} onChange={updateField} required /></label>
        <label>Phone<input name="phone" value={form.phone} onChange={updateField} /></label>
        <label>Service<select name="service" value={form.service} onChange={updateField}><option>Container destuffing</option><option>Lumper crew</option><option>Palletizing and wrapping</option><option>Cross-docking support</option><option>Warehouse support</option></select></label>
        <label>Location<input name="location" value={form.location} onChange={updateField} /></label>
        <label>Containers<input name="container_count" type="number" min="1" value={form.container_count} onChange={updateField} /></label>
        <label>Timeline<input name="timeline" value={form.timeline} onChange={updateField} placeholder="Today, this week, recurring" /></label>
        <label className="full-row">Details<textarea name="details" value={form.details} onChange={updateField} rows="5" /></label>
        <button className="primary-button" type="submit" disabled={status === "sending"}>{status === "sending" ? "Sending..." : "Submit Request"}</button>
        {status === "sent" && <p className="form-note success">Thanks. Your request was submitted.</p>}
        {status === "error" && <p className="form-note error">The form could not be sent. Please email quotes@fairviewcm.ca.</p>}
      </form>
    </section>
  );
}
